import { styled } from 'styled-components'

const ToastTitle = styled.span`
  font-weight: bold;
`

const ToastContent = ({
  title,
  children,
}: {
  title: React.ReactNode
  children: React.ReactNode
}) => {
  return (
    <>
      <ToastTitle>{title}</ToastTitle> {children}
    </>
  )
}
export default ToastContent
